var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUserComActive)?_c('div',_vm._l((_vm.numbers),function(number){return _c('div',{key:("usercom-listing-banner-" + number),attrs:{"id":("usercom-listing-banner-" + number)}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }